import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import PostCard from "../components/postCard"
import "../utils/styles.css"
import "../utils/normalize.css"
import "../utils/css/screen.css"

const AvailablePage = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title
  const posts = data.allMarkdownRemark.edges
  let postCounter = 0

  return (
    <Layout title={siteTitle}>
      <SEO
        title="Available Works - Organic Precision"
        keywords={[
          `Available`,
          `For Sale`,
          `Parametric`,
          `Wall Sculpture`,
          `Contemporary Art`,
          `Dimensional Wall Art`,
          `3D Wall Art `,
          `Modern Art`,
          `Flower Art`,
          `Mosaic Art`,
          `Wood Wall Art`,
          `Sacred Geometry`,
          `Abstract Art`,
          `Wall Object`,
          `3D Printing`,
          `Mandala Art`,
          `Geometric Art`,
          `Trippy Art`,
        ]}
      />

      <header className="page-head" style={{padding: "5vh 0 0 0", maxWidth: "800px"}}>
        <h2 style={{fontSize: "3.5rem"}}>
  <h2 style={{ fontSize: "3.5rem" }}>
    {posts.length === 0
      ? "All Works Currently Placed"
      : "Available Works"}
  </h2>
        </h2>
      </header>


      <div className="post-feed">
        {posts.length === 0 ? (
  <article className="post-content page-template no-image">
    <div className="post-content-body">

      <p>
        All recent works have been placed in private collections. There are no pieces currently available.
      </p>

      <p>
        If you are interested in acquiring a piece or learning about upcoming
        releases, I invite you to{" "}
        <a href="/contact?reason=purchase-inquiry">
          get in touch directly
        </a>.
      </p>

    </div>
  </article>
        ) : (
          posts.map(({ node }) => {
            postCounter++
            return (
              <PostCard
                key={node.fields.slug}
                count={postCounter}
                node={node}
                postClass={`post`}
              />
            )
          })
        )}
      </div>



    </Layout>
  )
}

export const query = graphql`
  query {
    site {
      siteMetadata {
        title
        description
      }
    }
    allMarkdownRemark(
      filter: {
        fileAbsolutePath: {regex: "/content/blog/"}
        frontmatter: {available: {eq: true}}
      }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
            thumbnail {
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED, width: 640)
              }
            }
            available
          }
        }
      }
    }
  }
`

export default AvailablePage
